/*
 * RANCLIC 商品ページ（main-product）の追加機能
 * - 価格下の「残りN点」（snippets/ranclic-stock-note.liquid）
 * - SP の追従カートボタン（snippets/ranclic-sticky-atc.liquid）。本体ボタンを上に通り過ぎたら出す。
 *   バー内のプルダウンで色・サイズを選べる（選ぶと本体の色見本・サイズを選んで change を発火し、既存の処理に任せる）
 *
 * バリアント切替は本体フォームの #formVariantId の change で受ける（product.js が bubbles 付きで発火）。
 * グローバルの Events 'variantinputchange' はクイックショップ等の別商品でも飛ぶので使わない。
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 767px)';

  function formatMoney(cents) {
    if (window.WAU && WAU.Helpers && typeof WAU.Helpers.formatMoney === 'function') {
      return WAU.Helpers.formatMoney(cents);
    }
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function stockLabel(note, productId, variantId) {
    if (!note || note.dataset.comingSoon === 'true') return '';
    var threshold = parseInt(note.dataset.threshold, 10) || 3;
    var byProduct = (window.ranclicInventories || {})[productId] || {};
    var inv = byProduct[variantId];
    if (!inv || inv.p === 'continue' || inv.q <= 0 || inv.q > threshold) return '';
    return (note.dataset.label || '').replace('[count]', String(inv.q));
  }

  var active = null;

  function teardown() {
    if (!active) return;
    active.observers.forEach(function (o) { o.disconnect(); });
    active.cleanups.forEach(function (fn) { fn(); });
    active = null;
  }

  function init() {
    teardown();

    var section = null;
    var bar = document.querySelector('[data-ranclic-sticky-atc]');
    var note = document.querySelector('[data-ranclic-stock-note]');
    if (bar) {
      section = document.getElementById('shopify-section-' + bar.dataset.sectionId);
    }
    if (!section && note) {
      section = note.closest('[data-section-type="product"]');
    }
    if (!section) return;

    active = { sectionId: bar ? bar.dataset.sectionId : null, observers: [], cleanups: [] };

    var idInput = section.querySelector('#formVariantId');
    var jsonEl = section.querySelector('.product-json');
    var product = null;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      product = null;
    }
    if (!idInput || !product) return;

    var variantsById = {};
    product.variants.forEach(function (v) {
      variantsById[String(v.id)] = v;
    });

    var sticky = bar ? setupSticky(bar, section, product) : null;

    // 画面で選ばれている色・サイズの組み合わせからバリアントを引く。存在しない組み合わせのとき、
    // product.js は #formVariantId を変えずに本体ボタンだけ無効にするので、入力欄の値だけでは判定できない
    function selectedState() {
      if (product.has_only_default_variant) return { variant: variantsById[String(idInput.value)] || null, values: [] };
      var values = [];
      var swatchGroups = section.querySelectorAll('.swatches__container.js-variant-selector');
      if (swatchGroups.length) {
        swatchGroups.forEach(function (group) {
          var checked = group.querySelector('.swatches__form--input:checked');
          values[parseInt(group.dataset.optionIndex, 10) - 1] = checked ? checked.value : null;
        });
      } else {
        section.querySelectorAll('select.js-variant-selector').forEach(function (select, i) {
          values[i] = select.value;
        });
      }
      if (!values.length) return { variant: variantsById[String(idInput.value)] || null, values: [] };
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] != null && v['option' + (j + 1)] !== values[j]) {
            match = false;
            break;
          }
        }
        if (match) return { variant: v, values: values };
      }
      return { variant: null, values: values };
    }

    function update() {
      var state = selectedState();
      var variant = state.variant;
      var label = variant ? stockLabel(note, product.id, variant.id) : '';

      if (note) {
        var noteLabel = note.querySelector('[data-ranclic-stock-label]');
        noteLabel.textContent = label;
        note.hidden = label === '';
      }
      if (sticky) sticky.setVariant(variant, label, state.values);
    }

    function onOptionChange(e) {
      if (!e.target.matches('.swatches__form--input, .js-variant-selector')) return;
      // product.js の処理（#formVariantId の更新・ボタンの状態）が終わってから読む
      window.setTimeout(update, 0);
    }

    idInput.addEventListener('change', update);
    section.addEventListener('change', onOptionChange);
    active.cleanups.push(function () {
      idInput.removeEventListener('change', update);
      section.removeEventListener('change', onOptionChange);
    });
    update();
  }

  function setupSticky(bar, section, product) {
    var mainButton = section.querySelector('.js-ajax-submit');
    var buttonArea = section.querySelector('.product-form__buttons');
    var errorMsg = section.querySelector('.js-error-msg');
    if (!mainButton || !buttonArea) return null;

    var stickyButton = bar.querySelector('[data-ranclic-sticky-button]');
    var selects = bar.querySelectorAll('[data-ranclic-sticky-option]');
    var priceEl = bar.querySelector('[data-ranclic-sticky-price]');
    var stockEl = bar.querySelector('[data-ranclic-stock-label]');
    var mql = window.matchMedia(MOBILE_QUERY);

    // セクションは読み込み時に transform が付くため、中に置くと position: fixed が画面基準にならない
    // body へ移すとセクションの再描画（テーマエディタ）で消えなくなるので、teardown で自分で外す
    document.body.appendChild(bar);
    bar.hidden = false;
    active.cleanups.push(function () {
      bar.remove();
      document.body.classList.remove('ranclic-sticky-atc-active');
      document.body.style.removeProperty('--ranclic-sticky-atc-height');
    });

    var mainOffscreen = false;

    // 追加処理中は cart.js が本体ボタンに disabled クラスを付ける
    function mainAdding() {
      return mainButton.classList.contains('disabled');
    }
    // 売り切れ・存在しない組み合わせは product.js が disabled 属性だけを付ける
    function mainUnavailable() {
      return mainButton.disabled && !mainAdding();
    }

    function syncButton() {
      var text = mainButton.getAttribute('value') || mainButton.textContent;
      stickyButton.textContent = text.trim();
      stickyButton.classList.toggle('is-locked', mainAdding());
      stickyButton.classList.toggle('is-unavailable', mainUnavailable());
    }

    function render() {
      // 売り切れの色を選んでもバーは隠さない（バーのプルダウンで別の色に戻せるように）
      var show = mql.matches && mainOffscreen;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyButton.tabIndex = show ? 0 : -1;
      selects.forEach(function (select) { select.tabIndex = show ? 0 : -1; });
      document.body.classList.toggle('ranclic-sticky-atc-active', show);
      if (show) {
        document.body.style.setProperty('--ranclic-sticky-atc-height', bar.offsetHeight + 'px');
      }
    }

    // 本体ボタンを上に通り過ぎたときだけ出す。ボタンがまだ下にある間に出すと、ファーストビューの
    // 商品名・「残りN点」を隠し、サイズを見ないまま既定の組み合わせでカートに入れられてしまう。
    // IntersectionObserver は一気にスクロールして画面を横切らなかったときに発火しないので、スクロール位置で判定する
    var ticking = false;
    function checkPosition() {
      ticking = false;
      var passed = buttonArea.getBoundingClientRect().bottom < 0;
      if (passed !== mainOffscreen) {
        mainOffscreen = passed;
        render();
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(checkPosition);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', onScroll);
    active.cleanups.push(function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      window.removeEventListener('load', onScroll);
    });
    // 画像の読み込みなどで配置が後からずれても判定し直す（スクロールイベントは発生しないため）
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(onScroll);
      ro.observe(section);
      active.observers.push(ro);
    }

    var buttonObserver = new MutationObserver(function () {
      syncButton();
      render();
    });
    buttonObserver.observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'value', 'class'], childList: true, characterData: true, subtree: true });
    active.observers.push(buttonObserver);

    // 追加に失敗したとき（在庫上限など）のメッセージは本体フォームの中に出るので、そこまで戻す。
    // fadeIn は毎フレーム style を書き換えるため、非表示→表示に変わった1回だけ反応する
    if (errorMsg) {
      var errorShown = errorMsg.style.display !== 'none';
      var errorObserver = new MutationObserver(function () {
        var shown = errorMsg.style.display !== 'none';
        if (shown && !errorShown && bar.classList.contains('is-visible')) {
          buttonArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        errorShown = shown;
      });
      errorObserver.observe(errorMsg, { attributes: true, attributeFilter: ['style'] });
      active.observers.push(errorObserver);
    }

    // バーのプルダウン：本体の色見本（ラジオ）またはプルダウンを選んで change を発火する。
    // バーの select に本体と同じ入力用のクラスや属性を付けると、product.js が二重に読んでしまうので付けない
    function selectOnPage(position, value) {
      var group = section.querySelector('.swatches__container.js-variant-selector[data-option-index="' + position + '"]');
      if (group) {
        var inputs = group.querySelectorAll('.swatches__form--input');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === value) {
            inputs[i].checked = true;
            inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
        return;
      }
      var pageSelects = section.querySelectorAll('select.js-variant-selector');
      var pageSelect = pageSelects[position - 1];
      if (pageSelect) {
        pageSelect.value = value;
        pageSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function onSelectChange(e) {
      selectOnPage(parseInt(e.target.dataset.ranclicStickyOption, 10), e.target.value);
    }
    selects.forEach(function (select) {
      select.addEventListener('change', onSelectChange);
    });

    // 各選択肢に「（売り切れ）」を付ける。判定は他のオプションの選択中の値との組み合わせ
    function markAvailability(values) {
      selects.forEach(function (select) {
        var position = parseInt(select.dataset.ranclicStickyOption, 10);
        Array.prototype.forEach.call(select.options, function (opt) {
          var available = product.variants.some(function (v) {
            if (!v.available || v['option' + position] !== opt.value) return false;
            for (var j = 0; j < values.length; j++) {
              if (j + 1 === position || values[j] == null) continue;
              if (v['option' + (j + 1)] !== values[j]) return false;
            }
            return true;
          });
          // 選択中の値には付けない（閉じたプルダウンの文字が切れる。売り切れはボタンの「Sold Out」で伝わる）
          var selected = opt.value === select.value;
          opt.textContent = available || selected ? opt.value : opt.value + select.dataset.soldOutSuffix;
        });
      });
    }

    stickyButton.addEventListener('click', function () {
      if (mainAdding()) return;
      // 売り切れの色を選んでいるときは、再入荷のリクエストボタンがある本体フォームへ戻す
      if (mainUnavailable()) {
        buttonArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainButton.click();
      // 名入れなど必須の入力欄が空だと、cart.js はエラー文を出さずに欄へ .required-error を付けるだけで止まる
      var invalid = section.querySelector('.required-error');
      if (invalid) {
        invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (typeof invalid.focus === 'function') invalid.focus({ preventScroll: true });
      }
    });

    if (mql.addEventListener) {
      mql.addEventListener('change', render);
      active.cleanups.push(function () { mql.removeEventListener('change', render); });
    }

    syncButton();
    checkPosition();

    return {
      setVariant: function (variant, label, values) {
        selects.forEach(function (select) {
          var position = parseInt(select.dataset.ranclicStickyOption, 10);
          var value = values[position - 1] != null ? values[position - 1] : (variant ? variant['option' + position] : null);
          if (value != null) select.value = value;
        });
        markAvailability(values.length ? values : (variant ? [variant.option1, variant.option2, variant.option3] : []));
        // 存在しない組み合わせでは前の価格を残さない（ボタンは「この組み合わせはありません」になる）
        priceEl.innerHTML = variant ? formatMoney(variant.price) : '';
        stockEl.textContent = label;
        syncButton();
        render();
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクションが再描画されたとき、body へ移した古いバーを片付けて作り直す
  document.addEventListener('shopify:section:unload', function (e) {
    if (active && active.sectionId && e.detail && e.detail.sectionId === active.sectionId) teardown();
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-section-type="product"]')) init();
  });
})();
